module.exports = __webpack_public_path__ + "img/35.d14de53a.jpg";